import React from "react";
import { createRoot } from "react-dom/client";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css"; // ⬅️ WAJIB: ukuran/visibilitas ikon FontAwesome
import App from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./responsive.css"; // ⬅️ dimuat terakhir agar override responsif menang
import "./hist-table-global.css"; // ⬅️ samakan style SEMUA tabel spt History

// CSS FontAwesome sudah diimpor statis di atas -> matikan auto-inject agar
// tidak dobel & tidak ada "flash" ikon raksasa sebelum CSS termuat.
config.autoAddCss = false;

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
